import { useSelector } from "react-redux";

export default function useBadgeFilename() {
  const language = useSelector((state) => state.ui.lang);
  const section = useSelector((state) => state.progress.section);

  let sectionAbbr;
  if (section === "PMAgile") sectionAbbr = "ag";
  if (section === "PMWaterfall") sectionAbbr = "wf";
  return `kickoff-badge-${sectionAbbr}${language}.png`;
}
